import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { QuickAddProvider } from "@/context/QuickAddContext";
import { AttentionProvider } from "@/context/AttentionContext";

export default function Shell() {
  const [collapsed, setCollapsed] = useState(localStorage.getItem("cc_sidebar") === "1");
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => { localStorage.setItem("cc_sidebar", collapsed ? "1" : "0"); }, [collapsed]);

  return (
    <AttentionProvider>
    <QuickAddProvider>
      <div className="flex h-screen overflow-hidden bg-[#F8FAFC]">
        <div className="hidden lg:block">
          <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
        </div>
        <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
          <SheetContent side="left" className="p-0 w-64">
            <SheetTitle className="sr-only">Navigation menu</SheetTitle>
            <Sidebar mobile onNavigate={() => setMobileOpen(false)} />
          </SheetContent>
        </Sheet>
        <div className="flex flex-1 flex-col overflow-hidden">
          <Topbar onMenu={() => setMobileOpen(true)} />
          <main className="flex-1 overflow-y-auto">
            <div className="mx-auto max-w-[1400px] p-4 sm:p-6 lg:p-8">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </QuickAddProvider>
    </AttentionProvider>
  );
}
